import { render, staticRenderFns } from "./BannerComponent.vue?vue&type=template&id=5539cab2&scoped=true"
import script from "./BannerComponent.vue?vue&type=script&lang=ts"
export * from "./BannerComponent.vue?vue&type=script&lang=ts"
import style0 from "./BannerComponent.vue?vue&type=style&index=0&id=5539cab2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5539cab2",
  null
  
)

export default component.exports